<template>
    <div @click="handleStarClick" class="star-wrap">
        <img :index="item" v-for="item in nUserScore" :key="item" :src="require('@/assets/images/user/house/completion-star-icon-big-ac.png')" alt="">
        <img :index="nUserScore + item" v-for="item in (nMaxScore - nUserScore)" :key="nUserScore + item" :src="require('@/assets/images/user/house/completion-star-icon-big.png')" alt="">
    </div>
</template>

<script>

export default {
    name: "startEvaluate",
    data() {
        return {
            // 最高评分
            nMaxScore: 5,
            // 当前评分
            nUserScore: 5,
        }
    },
    methods: {
        /**
         * 星星点击
         * @param target
         */
        handleStarClick({target}) {
            // 是否图片
            const isImage = target.localName === 'img';
            if (!isImage) return;
            this.nUserScore = Number.parseInt(target.attributes.index.value);
            // 注册一个事件
            this.$emit('scoreChange', this.nUserScore);
        }
    }
}
</script>

<style scoped lang="scss">
.star-wrap {
    display: flex;
    justify-content: center;
    margin-bottom: 32px;

    img {
        width: 44px;
        height: 44px;
        margin: 0 10px;
    }
}
</style>